module.exports = {"popup-view-incident":{"title":"View Incident Details","id":"popup-view-incident","className":"esri-icon-review","handler":"viewIncidentDetails","layer":"Incidents"},"popup-view-resource":{"title":"View Resource Details","id":"popup-view-resource","className":"esri-icon-review","handler":"viewResourceDetails","layer":"Resources"}}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/popupActions.json
// module id = 1114
// module chunks = 0